export type NeedsProMissingCardAcknowledgeInput = {
  appointment?: unknown
  practice?: {
    requireClientCcToBook?: boolean
    hasPaymentProvider?: boolean
  } | null
  isPaidNonPackage: boolean
  /** Selected or in-progress client (may lack id while creating a new client). */
  client?: unknown
}

/**
 * Whether pro manual booking must acknowledge / confirm missing card.
 * Must be true for brand-new clients (no id yet) as well as existing ones —
 * otherwise Save skips acknowledgeMissingCard and the backend rejects with
 * "Client has no card on file. Confirm to book anyway...".
 */
export function needsProMissingCardAcknowledge({
  appointment,
  practice,
  isPaidNonPackage,
  client
}: NeedsProMissingCardAcknowledgeInput): boolean {
  return (
    !appointment &&
    !!practice?.requireClientCcToBook &&
    !!practice?.hasPaymentProvider &&
    isPaidNonPackage &&
    !!client
  )
}
